import axios from "axios";
import { handleResponse, handleError } from "./apiUtils";
// const baseUrl = process.env.API_URL + "/users/";

// Wordpress Rest API
const baseUrl = `${window.appLocalizer.apiUrl}/wprk/v1/settings`;
const nonce = window.appLocalizer.nonce;

// const baseUrl = `http://localhost/wordpress/wp-json/wprk/v1/settings`;
// const nonce = `5c74968270`;
// const cookie =
//   "wordpress_test_cookie=WP Cookie check; wordpress_logged_in_bbfa5b726c6b7a9cf3cda9370be3ee91=VigneshDeva06|1641619925|mDbcLbkXx6QCfpRISDBiFZQO7lySqhkI7LYQ1NAMTNm|b7b6ab30b0dbc572397bd597fa353f2f6beb02b330988ca3c0336054c0fa071c; wp-settings-time-1=1641447151";

const wpHeaders = {
  "X-WP-NONCE": nonce,
//  Cookie: cookie,
  "Content-Type": "application/json",
};

//Freshmarketer credentials
// const fmBaseUrl = "https://fm-sandbox.freshmarketer.com/mas/api/v1/contacts";
// const fmToken = "cicatdf68siihalk66v0lu2hj5fmn24eevcd8d5r";
// const fmHeaders = {
// 		"Content-Type": "application/json",
// 		Accept: "application/json",
// 		"fm-token": fmToken,
// 		mode: "cors",
// 		// 'Origin': 'https://fm-sandbox.freshmarketer.com',
// 		"Access-Control-Allow-Origin": "*"
// };

// Wordpress
export function getUser() {
  const url = baseUrl;
  return axios
    .get(url, { headers: wpHeaders, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}

export function createUser(body) {
  return axios(baseUrl, {
    method: "POST",
    headers: wpHeaders,
    data: JSON.stringify(body),
    withCredentials: true,
  })
    .then(handleResponse)
    .catch(handleError);
}

// Freshmarketer
// export function getUser() {
// 	const url = baseUrl;
// 	return axios
// 		.get(url, { headers:wpHeaders, withCredentials: true })
// 		.then(handleResponse)
// 		.catch(handleError);
// }

// export function createWPUser(body) {
// 	return axios(baseUrl, {
// 		method: "POST",
// 		headers: wpHeaders,
// 		data: JSON.stringify(body),
// 		withCredentials: true,
// 	})
// 		.then((response) => handleResponse(response.data.contact))
// 		.catch(handleError);
// }

// export function createUser(body) {
// 	return axios(fmBaseUrl, {
// 		method: "PUT",
// 		headers: fmHeaders,
// 		data: JSON.stringify(body),
// 		withCredentials: true,
// 	})
// 		.then(createWPUser)
// 		.catch(handleError);
// }
